import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useGetPinQuery, useUpdatePinMutation, useGetBoardsQuery } from '../store/slices/apiSlice';
import { toast } from 'react-toastify';

function EditPin() {
  const { pinId } = useParams();
  const navigate = useNavigate();
  const { data: pin, isLoading: isPinLoading } = useGetPinQuery(pinId);
  const [updatePin, { isLoading }] = useUpdatePinMutation();
  const { data: boards = [] } = useGetBoardsQuery();

  const [formData, setFormData] = useState({
    title: '',
    prompt: '',
    category: '',
    boardId: '',
    tags: [],
    refHint: ''
  });
  const [tagInput, setTagInput] = useState('');

  useEffect(() => {
    if (pin) {
      setFormData({
        title: pin.title || '',
        prompt: pin.prompt || '',
        category: pin.category || '',
        boardId: pin.boardId || '',
        tags: pin.tags || [],
        refHint: pin.refHint || ''
      });
    }
  }, [pin]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAddTag = () => {
    if (tagInput.trim() && !formData.tags.includes(tagInput.trim())) {
      setFormData({ ...formData, tags: [...formData.tags, tagInput.trim()] });
      setTagInput('');
    }
  };

  const handleRemoveTag = (tagToRemove) => {
    setFormData({ ...formData, tags: formData.tags.filter(tag => tag !== tagToRemove) });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await updatePin({ id: pinId, ...formData }).unwrap();
      toast.success('Cập nhật prompt thành công!');
      navigate('/profile');
    } catch (error) {
      toast.error(error.data?.error || 'Không thể cập nhật prompt');
    }
  };

  if (isPinLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-8">Chỉnh Sửa Prompt</h1>

      <form onSubmit={handleSubmit} className="card p-8 space-y-6">
        <div>
          <label className="block text-sm font-medium mb-2">Tiêu đề *</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="input-field"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-2">Prompt *</label>
          <textarea
            name="prompt"
            value={formData.prompt}
            onChange={handleChange}
            className="input-field resize-none"
            rows="6"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-2">Danh mục</label>
          <input
            type="text"
            name="category"
            value={formData.category}
            onChange={handleChange}
            className="input-field"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-2">Bảng</label>
          <select
            name="boardId"
            value={formData.boardId}
            onChange={handleChange}
            className="input-field"
          >
            <option value="">Chọn bảng</option>
            {boards.map(board => (
              <option key={board.id} value={board.id}>{board.name}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium mb-2">Thẻ</label>
          <div className="flex gap-2 mb-2">
            <input
              type="text"
              value={tagInput}
              onChange={(e) => setTagInput(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), handleAddTag())}
              className="input-field flex-1"
              placeholder="Nhập thẻ và nhấn Enter"
            />
            <button type="button" onClick={handleAddTag} className="btn-secondary">
              Thêm
            </button>
          </div>
          <div className="flex flex-wrap gap-2">
            {formData.tags.map((tag, index) => (
              <span key={index} className="px-3 py-1 bg-primary-100 dark:bg-primary-900 text-primary-600 dark:text-primary-400 rounded-full text-sm flex items-center gap-2">
                {tag}
                <button type="button" onClick={() => handleRemoveTag(tag)} className="hover:text-red-600">
                  ✕
                </button>
              </span>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium mb-2">Gợi ý tham khảo</label>
          <textarea
            name="refHint"
            value={formData.refHint}
            onChange={handleChange}
            className="input-field resize-none"
            rows="3"
          />
        </div>

        <button type="submit" disabled={isLoading} className="btn-primary w-full">
          {isLoading ? 'Đang cập nhật...' : 'Cập nhật Prompt'}
        </button>
      </form>
    </div>
  );
}

export default EditPin;
